<h2 mat-dialog-title>{{title}}</h2>

<mat-dialog-content fxLayout="column" fxLayoutAlign="space-between stretch">

    <mat-progress-bar *ngIf="!isLoaded" mode="indeterminate"></mat-progress-bar>

    <ng-container *ngIf="isLoaded">
        <ap-payable-detail *ngIf="isAPPayable" [detail]="detail">
        </ap-payable-detail>

        <ap-payment-detail *ngIf="isAPPayment" [detail]="detail">
        </ap-payment-detail>

        <po-receipt-detail *ngIf="isPOReceipt" [detail]="detail">
        </po-receipt-detail>

        <gl-journal-entry-detail *ngIf="isGLJournalEntry" [detail]="detail">
        </gl-journal-entry-detail>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <ng-container *ngIf="cardActions.length > 0">
        <ng-container *ngFor="let action of cardActions">
            <button mat-button [mat-dialog-close]="action" [matTooltip]="action.label" class="noMinWidth" [attr.aria-label]="getActionAriaLabel(action)" [attr.telemetry]="getActionAriaLabel(action)">
                <mat-icon [ngStyle]="getActionStyle(action)">
                    {{action.icon}}
                </mat-icon>
            </button>
        </ng-container>
    </ng-container>

    <button mat-button mat-dialog-close [attr.telemetry]="getCloseActionAriaLabel()">
        Close
    </button>
</mat-dialog-actions>